import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Storage } from '@ionic/storage';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  responseData: any;
  
  constructor(
    public data: DataService,
    public storage: Storage
  ) { }

  init() {
    setTimeout(() => {
      this.getPriceList();
    }, 400);

  }

  getPriceList() {
    if (this.data.token !== '') {
      this.data.getData('pricelist').then((success) => {
        this.responseData = success;
        if (this.responseData.Status === true) {
          this.storage.set('pricelist', this.responseData.data);
        } else {
        }
      }, (error) => {
      });
    } else {
      setTimeout(() => {
        this.getPriceList();
      }, 400);
    }
  }

}
